export default {
  "fontFamily": "v-sans, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
  "fontFamilyMono": "v-mono, SFMono-Regular, Menlo, Consolas, Courier, monospace",
  "fontWeight": "400",
  "fontWeightStrong": "500",
  "cubicBezierEaseInOut": "cubic-bezier(.4, 0, .2, 1)",
  "cubicBezierEaseOut": "cubic-bezier(0, 0, .2, 1)",
  "cubicBezierEaseIn": "cubic-bezier(.4, 0, 1, 1)",
  "borderRadius": "5px",
  "borderRadiusSmall": "2px",
  "fontSize": "14px",
  "fontSizeMini": "12px",
  "fontSizeTiny": "12px",
  "fontSizeSmall": "14px",
  "fontSizeMedium": "14px",
  "fontSizeLarge": "15px",
  "fontSizeHuge": "16px",
  "lineHeight": "1.6",
  "heightMini": "16px",
  "heightTiny": "22px",
  "heightSmall": "28px",
  "heightMedium": "34px",
  "heightLarge": "40px",
  "heightHuge": "46px",
  "baseColor": "#FFF",
  "primaryColor": "#2130C8",
  "primaryColorHover": "#485BD3",
  "primaryColorPressed": "#1B27A3",
  "primaryColorSuppl": "#5C6EDB",
  "infoColor": "rgba(246, 246, 246, 0.9)",
  "infoColorHover": "rgba(220, 220, 220, 0.95)",
  "infoColorPressed": "rgba(200, 200, 200, 1)",
  "infoColorSuppl": "rgba(255, 255, 255, 0.85)",
  "successColor": "#95EE1A",
  "successColorHover": "#A8F13B",
  "successColorPressed": "#7ABE15",
  "successColorSuppl": "#BAF55C",
  "warningColor": "#FFD91D",
  "warningColorHover": "#FFE44C",
  "warningColorPressed": "#E6C200",
  "warningColorSuppl": "#FFED7A",
  "errorColor": "#f56c6c",
  "errorColorHover": "#ff8080",
  "errorColorPressed": "#d54949",
  "errorColorSuppl": "#ff9999",
  "textColorBase": "#000",
  "textColor1": "rgb(31, 34, 37)",
  "textColor2": "rgb(51, 54, 57)",
  "textColor3": "rgb(118, 124, 130)",
  "textColorDisabled": "rgba(194, 194, 194, 1)",
  "placeholderColor": "rgba(194, 194, 194, 1)",
  "placeholderColorDisabled": "rgba(209, 209, 209, 1)",
  "iconColor": "rgba(194, 194, 194, 1)",
  "iconColorHover": "rgba(146, 146, 146, 1)",
  "iconColorPressed": "rgba(175, 175, 175, 1)",
  "iconColorDisabled": "rgba(209, 209, 209, 1)",
  "opacity1": "0.82",
  "opacity2": "0.72",
  "opacity3": "0.38",
  "opacity4": "0.24",
  "opacity5": "0.18",
  "dividerColor": "rgb(239, 239, 245)",
  "borderColor": "rgb(224, 224, 230)",
  "closeIconColor": "rgba(102, 102, 102, 1)",
  "closeIconColorHover": "rgba(102, 102, 102, 1)",
  "closeIconColorPressed": "rgba(102, 102, 102, 1)",
  "closeColorHover": "rgba(0, 0, 0, .09)",
  "closeColorPressed": "rgba(0, 0, 0, .13)",
  "clearColor": "rgba(194, 194, 194, 1)",
  "clearColorHover": "rgba(146, 146, 146, 1)",
  "clearColorPressed": "rgba(175, 175, 175, 1)",
  "scrollbarColor": "rgba(0, 0, 0, 0.25)",
  "scrollbarColorHover": "rgba(0, 0, 0, 0.4)",
  "scrollbarWidth": "5px",
  "scrollbarHeight": "5px",
  "scrollbarBorderRadius": "5px",
  "progressRailColor": "rgba(235, 235, 235, 1)",
  "railColor": "rgb(219, 219, 223)",
  "popoverColor": "#fff",
  "tableColor": "#fff",
  "cardColor": "#fff",
  "modalColor": "#fff",
  "bodyColor": "#fff",
  "tagColor": "#eee",
  "avatarColor": "rgba(204, 204, 204, 1)",
  "invertedColor": "rgb(0, 20, 40)",
  "inputColor": "rgba(255, 255, 255, 1)",
  "codeColor": "rgb(244, 244, 248)",
  "tabColor": "rgb(247, 247, 250)",
  "actionColor": "rgb(250, 250, 252)",
  "tableHeaderColor": "rgb(250, 250, 252)",
  "hoverColor": "rgb(243, 243, 245)",
  "tableColorHover": "rgba(0, 0, 100, 0.03)",
  "tableColorStriped": "rgba(0, 0, 100, 0.02)",
  "pressedColor": "rgb(237, 237, 239)",
  "opacityDisabled": "0.5",
  "inputColorDisabled": "rgb(250, 250, 252)",
  "buttonColor2": "rgba(46, 51, 56, .05)",
  "buttonColor2Hover": "rgba(46, 51, 56, .09)",
  "buttonColor2Pressed": "rgba(46, 51, 56, .13)",
  "boxShadow1": "0 1px 2px -2px rgba(0, 0, 0, .08), 0 3px 6px 0 rgba(0, 0, 0, .06), 0 5px 12px 4px rgba(0, 0, 0, .04)",
  "boxShadow2": "0 3px 6px -4px rgba(0, 0, 0, .12), 0 6px 16px 0 rgba(0, 0, 0, .08), 0 9px 28px 8px rgba(0, 0, 0, .05)",
  "boxShadow3": "0 6px 16px -9px rgba(0, 0, 0, .08), 0 9px 28px 0 rgba(0, 0, 0, .05), 0 12px 48px 16px rgba(0, 0, 0, .03)"

}